import MotionEnter from "../../../../../utils/animation/motion/MotionEnter";
import PageCompanies from "../page/PageCompanies";
import PageConversations from "../page/PageConversations";
import PageProductsPrimary from "../page/PageProductsPrimary";
import PageUsers from "../page/PageUsers";

export default [
  {
    path: "/super-admin/conversations",
    Component: () => (
      <MotionEnter>
        <PageConversations />
      </MotionEnter>
    ),
  },
  {
    path: "/super-admin/companies",
    Component: () => (
      <MotionEnter>
        <PageCompanies />
      </MotionEnter>
    ),
  },
  {
    path: "/super-admin/products",
    Component: () => (
      <MotionEnter>
        <PageProductsPrimary />
      </MotionEnter>
    ),
  },
  {
    path: "/super-admin/users",
    Component: () => (
      <MotionEnter>
        <PageUsers />
      </MotionEnter>
    ),
  },
];
